export default "__VITE_ASSET__b3210fe0__"